import Service from "../../Service";
import Axios from "../../Config/API";
import {
    IAtividadeNotificacao,
    IAtividadeNotificacaoPorModulo,
    IGrupoNotificacao,
    INotificacao,
    IUltimasNotificacoes,
    IUltimasTransferencias,
} from "../../../Interfaces/Geral/Notificacao/NotificacaoInterfaces";

export const ListarAtividadesNotificacaoUsuarioService = () =>
    Service(
        Axios.get<Array<IAtividadeNotificacao>>(
            "/home/notificacoes/listaratividadesnotificacaousuario"
        )
    );

export const ListarAtividadesNotificacaoUsuarioPorModuloService = (
    idModulo: number
) =>
    Service(
        Axios.get<Array<IAtividadeNotificacaoPorModulo>>(
            `/home/notificacoes/listaratividadesnotificacaousuariomodulo?idModulo=${idModulo}`
        )
    );

export const AtualizarNotificacaoLidaService = (
    idNotificacao: number,
    lida: boolean
) =>
    Service(
        Axios.put(
            `/home/notificacoes/atualizarnotificacaolida?idNotificacao=${idNotificacao}&lida=${lida}`
        )
    );

export const ListarNotificacoesUsuarioService = (somenteLidas?: boolean) =>
    Service(
        Axios.get<Array<INotificacao>>(
            `/api/v1/home/notificacoes/listarnotificacoesusuario?somenteLidas=${!!somenteLidas}`
        )
    );

export const ListarUltimasNotificacoesUsuarioService = () =>
    Service(
        Axios.get<IUltimasNotificacoes>(
            `/home/notificacoes/listarultimasnotificacoesusuario`
        )
    );

export const ListarNotificacoesTransferenciaService = () =>
    Service(
        Axios.get<IUltimasTransferencias>(
            `/home/notificacoes/listarnotificacoestransferenciaatendimento`
        )
    );

export const ListarNotificacoesPorUsuarioService = (PAGINA: number) =>
    Service(
        Axios.get<Array<INotificacao>>(
            `/home/notificacoes/lstnotificacoesusuario?PAGINA=${PAGINA}`
        )
    );

export const AtualizarNotificacaoComoLidaService = (
    lstNotificacoes: Array<INotificacao>
) =>
    Service(
        Axios.put(
            `/home/notificacoes/marcanotificacoescomolidas`,
            lstNotificacoes
        )
    );

export const AtualizarNotificacaoComoNaoLidaService = (
    lstNotificacoes: Array<INotificacao>
) =>
    Service(
        Axios.put(
            `/home/notificacoes/marcanotificacoescomonaolidas`,
            lstNotificacoes
        )
    );

export const ListarGrupoNotificacoesService = (
    PAGINA: number,
    flTransferencia: boolean
) =>
    Service(
        Axios.get<IGrupoNotificacao>(
            `/home/notificacoes/listarnotificacoes?PAGINA=${PAGINA}&flTransferencia=${flTransferencia}`
        )
    );
